import { render, staticRenderFns } from "./ChatGPT.vue?vue&type=template&id=06e78630&scoped=true&"
import script from "./ChatGPT.vue?vue&type=script&lang=ts&"
export * from "./ChatGPT.vue?vue&type=script&lang=ts&"
import style0 from "./ChatGPT.vue?vue&type=style&index=0&id=06e78630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e78630",
  null
  
)

export default component.exports